module.exports = __webpack_public_path__ + "img/Infografis_EN_08.696bb398.jpg";